<template>
  <div>
    <Header />

    <main class="app-content">
      <div class="app-title">
        <div>
          <h1><i class="fa fa-dashboard"></i> SAHA VERİLERİ</h1>
        </div>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
          <li class="breadcrumb-item"><a href="#">AnaSayfa</a></li>
        </ul>
      </div>
      <div class="container" style="max-width: 100%;">
        <div class="row ">
          <div class="col-lg-4">
            <div v-for="value in result6" class="col-lg-12 ">
              <div v-if="value.reg_date == nowdate" style="font-size: 23px;font-weight: bolder;margin-bottom: 10px;">
                <button style="text-align: left; width : 100%" @click="routePageSub(value.id, value.keycode)"
                  class="btn btn-success" type="button">{{ value.id }} - {{ value.sahaName }}</button>
              </div>
              <div v-if="value.reg_date != nowdate" style="font-size: 23px;font-weight: bolder;margin-bottom: 10px;">
                <button style="text-align: left; width : 100%" @click="routePageSub(value.id, value.keycode)"
                  class="btn btn-danger " type="button">{{ value.id }} - {{ value.sahaName }}</button>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="col-lg-12 notespagerenkk">
              <div style=" font-size: 23px;font-weight: bolder;margin-bottom: 10px;">
                <p style="color: white;">Sorumlu =>{{ personelData.yrd_one }}</p>
              </div>
            </div>
            <div class="col-lg-12 notespagerenkk">
              <div style=" font-size: 23px;font-weight: bolder;margin-bottom: 10px;">
                <p style="color: white;">
                  Toplam Delgi Sayısı => {{ toplamsahadakinoktasayisi }} Adet
                </p>
              </div>
            </div>

            <div class="col-lg-12 notespagerenkk">
              <div style=" font-size: 23px;font-weight: bolder;margin-bottom: 10px;">
                <p id="status" style="color: white;">
                  Yapılan Delgi Sayısı => {{ toplamyapilandelgisayisi }} Adet
                </p>
              </div>
            </div>
            <div class="col-lg-12 notespagerenkk">
              <div style=" font-size: 23px;font-weight: bolder;margin-bottom: 10px;">
                <p id="status" style="color: white;">
                  Kalan Delgi Sayısı => {{ kalandelginetsayi }} Adet
                </p>
              </div>
            </div>
            <div class="col-lg-12 notespagerenkk">
              <div style=" font-size: 23px;font-weight: bolder;margin-bottom: 10px;">
                <p id="status" style="color: white;">
                  Yüzdelik İlerleme Oranı => %{{ kalanyuzdelikoran }} 
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="col-lg-12 notespagerenkk2">
              <div style=" font-size: 23px;font-weight: bolder;margin-bottom: 10px;">
                <p style="color: white;">
                  DELİK ÇAPI => {{ result.cap_delgi }}cm
                </p>
              </div>
            </div>
            <div class="col-lg-12 notespagerenkk2">
              <div style=" font-size: 23px;font-weight: bolder;margin-bottom: 10px;">
                <p style="color: white;">DERİNLİK => {{ result.derinlik }}cm</p>
              </div>
            </div>
            <div class="col-lg-12 notespagerenkk2">
              <div style=" font-size: 23px;font-weight: bolder;margin-bottom: 10px;">
                <p style="color: white;">
                  DELGİ BİRİM FİYATI => {{ result.fiyat_delgi }}₺
                </p>
              </div>
            </div>
            <div class="col-lg-12 notespagerenkk2">
              <div style=" font-size: 23px;font-weight: bolder;margin-bottom: 10px;">
                <p style="color: white;">
                  TOPLAM İŞ BEDELİ =>
                  {{ toplamisbedeli }}
                </p>
              </div>
            </div>
            <div class="col-lg-12 notespagerenkk2">
              <div style=" font-size: 23px;font-weight: bolder;margin-bottom: 10px;">
                <p style="color: white;">
                  HAKEDİLEN MİKTAR =>
                  {{ toplamhakedilentutar }}
                </p>
              </div>
            </div>

            <!-- <div class="col-lg-12 notespagerenkk2">
              <div style=" font-size: 23px;font-weight: bolder;margin-bottom: 10px;">
                <p style="color: white;">
                  DELİK BAŞI GENEL MALİYET => {{ detailData.maliyet }}
                </p>
              </div>
            </div>
            <div class="col-lg-12 notespagerenkk2">
              <div style=" font-size: 23px;font-weight: bolder;margin-bottom: 10px;">
                <p style="color: white;">
                  DELİK BAŞI KAR KDV DAHİL => {{ detailData.kar }}
                </p>
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <div style="border: 1px solid;position:absolute;">
        <button @click="pdfdownload()" class="btn btn-info" type="button">
          TOPLU PDF İNDİR
        </button>
        <button @click="exceldownload()" class="btn btn-primary" type="button">
          EXCEL İNDİR
        </button>
        <button @click="ozetdosya()" class="btn btn-success" type="button">
          ÖZET İNDİR
        </button>
        <button  @click="ozetdosya2()" class="btn btn-primary" type="button">
          SAHA FİNANS HESAPLA
        </button>
        <button  v-if="buttonid == 45" @click="sahahakedis()" class="btn btn-secondary" type="button">
         SAHA HAKEDİŞİ 
        </button>
        <button @click="notesSaha()" class="btn btn-warning" type="button"
          style="animation: blinker 1s linear infinite;">
          NOTLAR {{ result4 }}
        </button>
        <button @click="cari()" class="btn btn-success" type="button" style="animation: blinker 1s linear infinite;">
          CARİ
        </button>
      </div>
      <br>
      <br />
      <br />
      <div class="row">
        <div class="col-md-12">
          <div class="tile">
            <div class="tile-body">
              <table class="table table-hover table-bordered" id="sampleTable">
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Makina</th>
                    <th>Delgi Adeti</th>
                    <th>Motor</th>
                    <th>Operatör</th>
                    <th>Açıklama Bir</th>
                    <th>Açıklama iki</th>
                    <th>Kullanıcı Adı</th>
                    <th>Belge Tarihi</th>
                    <th>Oluşturma Tarhi</th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </main>
    <Sidebar />
  </div>
</template>

<script>
import Header from "./default/Header";
import Sidebar from "./default/Sidebar";
import axios from "axios";
import store from "../store";
import SahaDetail from "./SahaDetail.vue";
export default {
  data() {
    return {
      result: [],
      result2: [],
      category: [],
      personelData: [],

      detailData: [],
      isyuzdesi: "",
      noteId: "",
      buttonid: "",
      saha_idm: this.$route.query.idm,
      keys: this.$route.query.idm.substr(3),
    };
  },
  mounted: function () {
    window.scrollTo(0, 0);

    let date = new Date();
    this.nowdate = date.getDate();

    var token = localStorage.getItem("token");
    var admin_token = localStorage.getItem("admin_token");
    var id = localStorage.getItem("id");
    this.buttonid = localStorage.getItem("id");
    if (!token) {
      this.$router.push("/login");
    }
    var datas = {
      saha_id: this.saha_idm.substr(0, 3),
      token: token,
      keys: this.saha_idm.substr(3),
      admin_token: admin_token,
      id: id,
      status: 0,

    };

    let dataUrl =
      store.state.base_url + "AslanSahalar/getBySahaDetail.php?key=123";
    axios.post(dataUrl, JSON.stringify(datas)).then((response) => {
      this.result = response.data.data[0];
      this.personelData = response.data.temp;
      this.detailData = response.data.data[0].detail;
    });

    let dataUrl3 =
      store.state.base_url + "AslanSahalar/getAllYapilanStatus.php?key=123";
    axios.post(dataUrl3, JSON.stringify(datas)).then((response) => {
      this.result2 = response.data;
    });

    let dataUrl5 =
      store.state.base_url + "AslanSahalar/getByNotesCount.php?key=123";
    axios.post(dataUrl5, JSON.stringify(datas)).then((response) => {
      this.result4 = response.data;
    });
    let dataUrl6 =
      store.state.base_url + "MainPage/getBySubCompany.php?key=123";
    axios.post(dataUrl6, JSON.stringify(datas)).then((response) => {
      this.result6 = response.data;
      this.result7 = response.data[0];
      this.toplamyapilandelgisayisi = response.data[0].derinlik;
      this.toplamsahadakinoktasayisi = parseInt(response.data[0].toplam_delgi);
      this.kalandelginetsayi = this.toplamsahadakinoktasayisi - this.toplamyapilandelgisayisi;
      this.toplamisbedeli = this.toplamsahadakinoktasayisi * parseInt(response.data[0].fiyat_delgi);;
      this.toplamisbedeli = this.toplamisbedeli.toLocaleString('tr-TR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) + ' ₺';
      this.toplamhakedilentutar = this.toplamyapilandelgisayisi * parseInt(response.data[0].fiyat_delgi);;
      this.toplamhakedilentutar = this.toplamhakedilentutar.toLocaleString('tr-TR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) + ' ₺ ';
      this.kalandelginetsayi = this.toplamsahadakinoktasayisi - this.toplamyapilandelgisayisi;
      this.kalanyuzdelikoran = parseInt((this.toplamyapilandelgisayisi / this.toplamsahadakinoktasayisi)*100);
      console.log(this.kalanyuzdelikoran)
    });

    var results = this.result;
    let url =
      store.state.base_url + "MainPage/getAllSubDelgi.php?key=123";
    var datas2 = {
      saha_id: this.saha_idm.substr(0, 3),
      token: token,
      id: id,
      status: 0,
    };

    axios
      .post(url, JSON.stringify(datas2))
      .then((response) => {
        datas2 = response.data;
        //    console.log(datas2);
        var table = $("#sampleTable").DataTable(
          {
            pageLength: 30,
            order: [[0, 'desc']]
          });
        $.each(datas2, function (index, value) {
          table.row
            .add([
              value["id"],
              value["makina"],
              value["delgiadeti"],
              value["motorbaslama"],
              value["operatorname"],
              value["aciklamaone"],
              value["aciklamatwo"],
              value["nameSurname"],
              value["date"],
              value["reg_date"],
            ])
            .draw(false);
        });

        $("#sampleTable tbody").on("click", "tr", function () {
          var data = table.row(this).data();
          results.id = data[0];
          window.location.href = "#/updatedelgi?id=" + results.id;
        });
      })
      .catch((err) => {
        //console.log(err.response);
      });
    let url2 =
      store.state.base_url + "AslanSahalar/getAllDelgiCategories.php?key=123";
    axios
      .post(url2)
      .then((response) => {
        this.category = response.data;
      })
      .catch((err) => {
        console.log(err.response);
      });
  },
  methods: {
    formatTL(number) {
      return number.toLocaleString('tr-TR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) + ' ₺';
    },

    goGider: function () {
      window.location.href = "#/studentsdetail?id=" + this.saha_idm;
    },
    routePageSub: function (id, key) {
      window.location.href = "#/notesPage?idm=" + id + key;
    },
    gomakinefilter: function () {
      window.location.href = "#/makinefiltrele?idm=" + this.saha_idm;
    },
    gosahadetail: function () {
      window.location.href = "#/sahadetail?idm=" + this.saha_idm;
    },
    notesSaha: function () {
      window.location.href = "#/notesSaha?idm=" + this.saha_idm;
    },
    cari: function () {
      window.location.href = "#/cari?idm=" + this.saha_idm;
    },
    changeDetail() {
      let dataUrl3 =
        store.state.base_url + "AslanSahalar/getAllYapilanStatus.php?key=123";
      axios.post(dataUrl3, JSON.stringify(datas)).then((response) => { });
    },

    //********************************************************************************** */
    statusone() {
      var dataStatus = {
        admin_id: localStorage.getItem("id"),
        admin_token: localStorage.getItem("token"),
        saha_id: this.saha_idm.substr(0, 3),
      };
      let dataUrl3 =
        store.state.base_url + "AslanSahalar/statusone.php?key=123";
      axios.post(dataUrl3, JSON.stringify(dataStatus)).then((response) => {
        this.$swal({
          text: "SAHA BAŞARIYLA KALDIRILDI",
          icon: "success",
          closeOnClickOutside: false,
        });
      });
    },
    statuszero() {
      var dataStatus = {
        admin_id: localStorage.getItem("id"),
        admin_token: localStorage.getItem("token"),
        saha_id: this.saha_idm.substr(0, 3),
      };
      let dataUrl3 =
        store.state.base_url + "AslanSahalar/statuszero.php?key=123";
      axios.post(dataUrl3, JSON.stringify(dataStatus)).then((response) => {
        if (response.data == true) {
          this.$swal({
            text: "SAHA BAŞARIYLA GERİ YÜKLENDİ",
            icon: "success",
            closeOnClickOutside: false,
          });
        }
      });
    },
    pdfdownload() {
      window.open(`https://www.apidosya.aslanyazilimm.com/DosyaApi/allpdfdownload.php?key=23874628714&keyword=${this.saha_idm}`, "_blank");
    },
    exceldownload() {
      window.open(`https://www.apidosya.aslanyazilimm.com/DosyaApi/allExcelDownload.php?key=7264972863481679&keyword=${this.saha_idm}`, "_blank");
    },
    ozetdosya() {
      window.open(`https://www.apidosya.aslanyazilimm.com/DosyaApi/ozetdosya.php?key=7264972863481679&keyword=${this.saha_idm}`, "_blank");
    },
    ozetdosya2() {
      window.open(`https://www.apidosya.aslanyazilimm.com/DosyaApi/ozetdosya2.php?key=7264972863481679&keyword=${this.saha_idm}`, "_blank");
    },
    sahahakedis() {
      window.open(`https://www.apidosya.aslanyazilimm.com/DosyaApi/sahahakedis.php?key=7264972863481679&keyword=${this.saha_idm}`, "_blank");
    },
    //*********************************************************************************** */

    changecategory(event) {
      // changeDetail();
      var table1 = $("#sampleTable").DataTable();
      table1.clear();
      table1.destroy();
      this.categoryId = event.target.value;
      var url =
        store.state.base_url + "AslanSahalar/getByIdDelgiSaha.php?key=123";
      this.categoryId = this.categoryId - 1;
      var datas = {
        id: localStorage.getItem("id"),
        token: localStorage.getItem("token"),
        status: this.categoryId,
        saha_id: this.saha_idm.substr(0, 3),
      };
      let dataUrl3 =
        store.state.base_url + "AslanSahalar/getAllYapilanStatus.php?key=123";
      axios.post(dataUrl3, JSON.stringify(datas)).then((response) => {
        this.result2 = response.data;
        console.log(this.result2.data.yapilanislem);
        //  this.result = response.data.data[0];
        //this.personelData = response.data.temp;
        // this.detailData2 = response.data.data[0].detail;
      });
      axios
        .post(url, JSON.stringify(datas))
        .then((response2) => {
          var response2 = response2.data;
          var table2 = $("#sampleTable").DataTable();
          $.each(response2, function (index, value) {
            table2.row
              .add([
                value["id"],
                value["makina"],
                value["delgiadeti"],
                value["motorbaslama"],
                value["operatorname"],
                value["aciklamaone"],
                value["aciklamatwo"],
                value["nameSurname"],
                value["date"],
                value["reg_date"],
              ])
              .draw(false);
          });
        })
        .catch((error) => {
          console.log(error.response);
        });
    },
  },
  components: {
    Header,
    Sidebar,
  },
};
</script>

<style>
#spanRegdate {
  font-size: 20px;
  text-align: right;
  display: block;
  margin-right: 10px;
  color: #c1163b;
}

#spanContent {
  font-size: 25px;
  margin-right: 10px;
  color: #c66a7e;
}

#pid1 {
  border-radius: 3px 22px;
  background-color: #5fe0d7;
  text-align: center;
  font-size: 25px;
}

#pid2 {
  border-radius: 3px 22px;
  background-color: #5fe0d7;
  text-align: center;
  font-size: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/MainPage.vue